import '../scss/style.scss';
import { nodeListForEach } from './addons/polyfills';
import ScrollTo from './components/Scrollto';
import ModalControler from './components/modal/ModalControler';
import FormInputEventsJs from './components/FormInputEvents';
import Forms from './components/Forms';
import StoriesSlider from './components/StoriesSlider';
import ClientsSlider from './components/ClientsSlider';
import PlansSlider from './components/PlansSlider';
import Cookie from './components/Cookie';
import Mobile from './components/Mobile';
import InView from './components/InView';
import Paralax from './components/Paralax';
import Kringel from './components/Kringel';
import FeaturesSlider from './components/FeaturesSlider';
import BackToTopColor from './components/BackToTopColor';
import VideoLoad from './components/VideoLoad';
import VideoPlay from './components/VideoPlay';
import Calculator from './components/calculator/Calculator';
import TabControler from './components/tab/TabControler';
import CopyUrl from './components/CopyUrl';
import Toggler from './components/Toggler';
import HeroImages from './components/heroImages';
import Faq from './components/Faq';
import HeaderScroll from './components/HeaderScroll';
import BestCharts from './components/BestCharts';
import BestNav from './components/BestNav';

nodeListForEach();

const inits = (): void => {
  new ScrollTo('[data-scrollto]');
  const modalControler = new ModalControler();
  FormInputEventsJs.inputsEvents();
  Forms.initForm();
  Forms.initRecaptcha();
  StoriesSlider.init();
  PlansSlider.init();
  Cookie.init();
  Mobile.init();
  InView.init();
  // Paralax.init();
  Kringel.init();
  FeaturesSlider.init('.features__slider');
  BackToTopColor.init();
  ClientsSlider.init();
  VideoLoad.init();
  VideoPlay.init();
  CopyUrl.init();
  Toggler.init();
  HeroImages.initHeroImages();
  Faq.init();
  HeaderScroll.init();
  BestCharts.init();
  BestNav.init();
  new Calculator('.js-calculator');
  new TabControler();
};

const onScroll = (e: Event): void => {};

const onResize = (e: Event): void => {
  onScroll(e);
};

const onLoad = (e: Event): void => {
  document.body.classList.remove('body-loading');
  document.body.classList.add('body-loaded');
  inits();
  onResize(e);
};

window.addEventListener('load', onLoad);
window.addEventListener('resize', onResize);
window.addEventListener('scroll', onScroll);
